import { atom } from 'recoil'

interface IMainLayoutAtomState {
  navigationOpen: boolean
}

const mainLayoutAtom = atom<IMainLayoutAtomState>({ key: 'mainLayout', default: { navigationOpen: false } })
export default mainLayoutAtom
